import { definedNotNull } from '@df/common';

const invalidWords = [
  'NAMN',
  'DATUM',
  'KOMPLETTERA',
  'ANTAL',
  'BYRÅ',
  'BELOPP',
  'PROCENT',
  'FÖREGÅENDE RÄKENSKAPSÅR',
  '20YY',
  'PROJEKTSYSTEM',
  'REDOVISNINGSPROGRAM',
  'LÖNEPROGRAM',
  'BOKSLUTSPROGRAM',
  'AFFÄRSSYSTEM',
  'BUTIKSDATASYSTEM',
  'KORTTERMINAL',
  'VERKSAMHETSSYSTEM',
];

/**
 * Joins an array of strings or numbers into a single string with proper use of the conjunction "och".
 *
 * @param {Array<string | number>} array - The array of strings or numbers to be joined.
 * @returns {string} A string with the array elements joined appropriately.
 *
 * @example
 * joinWithAnd(['äpple', 'banan', 'körsbär']); // returns "äpple, banan och körsbär"
 * joinWithAnd(['äpple', 'banan']);            // returns "äpple och banan"
 * joinWithAnd(['äpple']);                     // returns "äpple"
 */
export function joinWithAnd(array: (string | number)[]): string {
  const len = array.length;
  if (len > 2) {
    return `${array.slice(0, len - 1).join(', ')} och ${array[len - 1]}`;
  }

  if (len === 1) {
    return array.join();
  }

  return array.join(' och ');
}

export function getInvalidWords(text: string | undefined | null): string[] {
  return invalidWords.filter((invalidWord) => text?.includes(invalidWord));
}

export function includesFilter(text: string | undefined, filter: string, replaceRegex?: RegExp) {
  if (replaceRegex) {
    return (
      definedNotNull(text) &&
      text
        .toLowerCase()
        .replaceAll(replaceRegex, '')
        .includes(filter.toLowerCase().replaceAll(replaceRegex, ''))
    );
  }
  return definedNotNull(text) && text.toLowerCase().includes(filter.toLowerCase());
}
